// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

body {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 18px;
  /* background-color: #ebedec; */
  background-color:gray;
}

button {
  padding: 16px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 16px;
  background-color: black;
  color: white;
  border-radius: 8px;
  cursor: pointer;
}

h3, h4 {
  margin-bottom: 0;
}

.logo {
  width: 100px;
  height: 100%;
  margin-left: 20px;
}

.pythonlogo {
  width: 36px;
  height: 100%;
  margin: 0 10px 0 5px;
}


#page-body {
  /* max-width: 700px; */
  margin: auto;
  padding-top: 90px;
  padding-right: 20px; 
  padding-left: 20px;
}

#page-body h1 {
  color: #FFEA00;
  /* color:#FFFF8F; */
  text-shadow: black 2px 2px 3px;
}

.flex-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;
  background-color: white;
  border-radius: 10px;
}


.flex-container h3 {
  display: block;
  margin-bottom: 10px;
  padding: 20px;
  color: white;
  text-shadow: black 1px 1px 5px;  
  background-color:gray;
  border-radius: 5px;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}


.flex-item {
  width: 364px;
  margin: 10px;
}

.flex-item a {
  display: flex;
  line-height: 2em;
  background-color: lightblue;
  border: 2px solid blue;
  border-radius: 10px;
  padding: 5px;
  text-decoration: none;
}

.flex-item-large {
  width: 546px;
  margin: 10px;
}

.flex-item-large a {
  display: flex;
  line-height: 2em;
  background-color: lightblue;
  border: 2px solid blue;
  border-radius: 10px;
  padding: 5px;
  text-decoration: none;
}

#advt {
  background-color: white;
  /* border: none; */
  border-radius: 0;
  padding: 0;
  border: none;
  border-left: 2px solid black;
}

.flex-video {
  width: 550px;
  margin: 10px;  
}

.flex-photo {
  width: 100%;
}

.youtube-logo {
  width: 96px;
}

.instructor-img {
  width: 70%;
  height: auto;
}

.languageicon {
  width: 64px;
  margin: 10px;
}

.attributions {
  display: flex;
}
.attributions a {
  font-size: 0.5em;
  line-height: 0.8em;
  background-color: inherit;
  border: none;
  border-radius: 0px;
  padding: 5px;
  text-decoration: none;  
}

article {
  background-color: white;
  margin: 10px;
  padding: 2px 15px;
  border-radius: 10px;
}

article h2 {
  margin-bottom: -5px;
}

.articledate {
  display: block;
  margin-top: 0px;
  padding-bottom: 10px;
  font-size: .8em;
  border-bottom: 3px solid gray;
}

article p {
  margin: 0.5em;
}

.article-list-item {
  text-decoration: none;
  color: black;
  padding: 16px 0 0 0;
}

.article-list-item p {
  padding-bottom: 32px;
  border-bottom: 2px solid black;
}

#add-comment-form {
  border-bottom: 2px solid black;
  padding: 16px;
}

#add-comment-form h3 {
  margin-bottom: 16px;
}

#add-comment-form input, textarea {
  display: block;
  width: 300px;
  padding: 8px;
  border-radius: 8px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 18px;
  border: 2px solid black;
  margin-bottom: 16px;
}

#add-comment-form button {
  width: 320px;
}

#upvotes-section button, p {
  display: inline-block;
  margin-right: 16px;
}

.comment {
  border-bottom: 2px solid black;
  padding: 16px;
}

table {
  font-size: 0.9em;
}

input {
  padding: 5px;
  font-size: 1.25em;
}

select {
  padding: 5px;
  font-size: 1.25em;
}

label {
  font-weight: bold;
}

.sublabel {
  font-weight: normal;
  font-size: 0.9em;
}
.command {
  text-align: center;
}

.submit {
  background-color: blue;
  color: white;
  text-transform: capitalize;
  margin-top: 10px;
  padding: 10px;
  border-radius: 10px;
  cursor: pointer;
}

.courseTbl {
  font-size: 0.8em;
}

.tuitionTime {
  font-size: 0.7em;
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,4DAA4D;EAC5D,eAAe;EACf,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;;AAGA;EACE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,uBAAuB;EACvB,mBAAmB;AACrB;;;AAGA;EACE,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,8BAA8B;EAC9B,qBAAqB;EACrB,kBAAkB;EAClB,2CAA2C;AAC7C;;;AAGA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,2BAA2B;EAC3B,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,2BAA2B;EAC3B,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,4DAA4D;EAC5D,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":["* {\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  font-size: 18px;\n  /* background-color: #ebedec; */\n  background-color:gray;\n}\n\nbutton {\n  padding: 16px;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  font-size: 16px;\n  background-color: black;\n  color: white;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\nh3, h4 {\n  margin-bottom: 0;\n}\n\n.logo {\n  width: 100px;\n  height: 100%;\n  margin-left: 20px;\n}\n\n.pythonlogo {\n  width: 36px;\n  height: 100%;\n  margin: 0 10px 0 5px;\n}\n\n\n#page-body {\n  /* max-width: 700px; */\n  margin: auto;\n  padding-top: 90px;\n  padding-right: 20px; \n  padding-left: 20px;\n}\n\n#page-body h1 {\n  color: #FFEA00;\n  /* color:#FFFF8F; */\n  text-shadow: black 2px 2px 3px;\n}\n\n.flex-container {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-evenly;\n  background-color: white;\n  border-radius: 10px;\n}\n\n\n.flex-container h3 {\n  display: block;\n  margin-bottom: 10px;\n  padding: 20px;\n  color: white;\n  text-shadow: black 1px 1px 5px;  \n  background-color:gray;\n  border-radius: 5px;\n  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n}\n\n\n.flex-item {\n  width: 364px;\n  margin: 10px;\n}\n\n.flex-item a {\n  display: flex;\n  line-height: 2em;\n  background-color: lightblue;\n  border: 2px solid blue;\n  border-radius: 10px;\n  padding: 5px;\n  text-decoration: none;\n}\n\n.flex-item-large {\n  width: 546px;\n  margin: 10px;\n}\n\n.flex-item-large a {\n  display: flex;\n  line-height: 2em;\n  background-color: lightblue;\n  border: 2px solid blue;\n  border-radius: 10px;\n  padding: 5px;\n  text-decoration: none;\n}\n\n#advt {\n  background-color: white;\n  /* border: none; */\n  border-radius: 0;\n  padding: 0;\n  border: none;\n  border-left: 2px solid black;\n}\n\n.flex-video {\n  width: 550px;\n  margin: 10px;  \n}\n\n.flex-photo {\n  width: 100%;\n}\n\n.youtube-logo {\n  width: 96px;\n}\n\n.instructor-img {\n  width: 70%;\n  height: auto;\n}\n\n.languageicon {\n  width: 64px;\n  margin: 10px;\n}\n\n.attributions {\n  display: flex;\n}\n.attributions a {\n  font-size: 0.5em;\n  line-height: 0.8em;\n  background-color: inherit;\n  border: none;\n  border-radius: 0px;\n  padding: 5px;\n  text-decoration: none;  \n}\n\narticle {\n  background-color: white;\n  margin: 10px;\n  padding: 2px 15px;\n  border-radius: 10px;\n}\n\narticle h2 {\n  margin-bottom: -5px;\n}\n\n.articledate {\n  display: block;\n  margin-top: 0px;\n  padding-bottom: 10px;\n  font-size: .8em;\n  border-bottom: 3px solid gray;\n}\n\narticle p {\n  margin: 0.5em;\n}\n\n.article-list-item {\n  text-decoration: none;\n  color: black;\n  padding: 16px 0 0 0;\n}\n\n.article-list-item p {\n  padding-bottom: 32px;\n  border-bottom: 2px solid black;\n}\n\n#add-comment-form {\n  border-bottom: 2px solid black;\n  padding: 16px;\n}\n\n#add-comment-form h3 {\n  margin-bottom: 16px;\n}\n\n#add-comment-form input, textarea {\n  display: block;\n  width: 300px;\n  padding: 8px;\n  border-radius: 8px;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  font-size: 18px;\n  border: 2px solid black;\n  margin-bottom: 16px;\n}\n\n#add-comment-form button {\n  width: 320px;\n}\n\n#upvotes-section button, p {\n  display: inline-block;\n  margin-right: 16px;\n}\n\n.comment {\n  border-bottom: 2px solid black;\n  padding: 16px;\n}\n\ntable {\n  font-size: 0.9em;\n}\n\ninput {\n  padding: 5px;\n  font-size: 1.25em;\n}\n\nselect {\n  padding: 5px;\n  font-size: 1.25em;\n}\n\nlabel {\n  font-weight: bold;\n}\n\n.sublabel {\n  font-weight: normal;\n  font-size: 0.9em;\n}\n.command {\n  text-align: center;\n}\n\n.submit {\n  background-color: blue;\n  color: white;\n  text-transform: capitalize;\n  margin-top: 10px;\n  padding: 10px;\n  border-radius: 10px;\n  cursor: pointer;\n}\n\n.courseTbl {\n  font-size: 0.8em;\n}\n\n.tuitionTime {\n  font-size: 0.7em;\n  font-weight: 700;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
